import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlignCentreHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M7.75 8.5h1.5V7h-1.5zm1.75.25v6.5H11v-6.5zm-.25 6.75h-1.5V17h1.5zm-1.75-.25v-6.5H6v6.5zm.25.25a.25.25 0 0 1-.25-.25H6c0 .966.784 1.75 1.75 1.75zm1.75-.25a.25.25 0 0 1-.25.25V17A1.75 1.75 0 0 0 11 15.25zM9.25 8.5a.25.25 0 0 1 .25.25H11A1.75 1.75 0 0 0 9.25 7zM7.75 7A1.75 1.75 0 0 0 6 8.75h1.5a.25.25 0 0 1 .25-.25zM14.75 10.5h1.5V9h-1.5zm1.75.25v2.5H18v-2.5zm-.25 2.75h-1.5V15h1.5zm-1.75-.25v-2.5H13v2.5zm.25.25a.25.25 0 0 1-.25-.25H13c0 .966.784 1.75 1.75 1.75zm1.75-.25a.25.25 0 0 1-.25.25V15A1.75 1.75 0 0 0 18 13.25zm-.25-2.75a.25.25 0 0 1 .25.25H18A1.75 1.75 0 0 0 16.25 9zM14.75 9A1.75 1.75 0 0 0 13 10.75h1.5a.25.25 0 0 1 .25-.25z"
    />
    <path
      fill="currentColor"
      d="M17.75 11.25a.75.75 0 0 0 0 1.5zm1.5 1.5a.75.75 0 0 0 0-1.5zm-1.5 0h1.5v-1.5h-1.5zM10.75 11.25a.75.75 0 0 0 0 1.5zm2.5 1.5a.75.75 0 0 0 0-1.5zm-2.5 0h2.5v-1.5h-2.5zM4.75 11.25a.75.75 0 0 0 0 1.5zm1.5 1.5a.75.75 0 0 0 0-1.5zm-1.5 0h1.5v-1.5h-1.5z"
    />
  </svg>
);
export default SvgAlignCentreHorizontal;
